// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d7a2e97c","981":"cd8580e0"}[chunkId] + ".chunk.js";
};